import { __assign } from "tslib";
import { reduxKey } from './constants';
import get from 'lodash/get';
export function getWatchState(state, username) {
    return username ? state[reduxKey][username.toLowerCase()] : {};
}
export function getIsInitialized(state, username) {
    return (Boolean(username) &&
        state[reduxKey] !== undefined &&
        state[reduxKey][username.toLowerCase()] !== undefined);
}
export function getUserWatchState(state, user, initialState) {
    var _a, _b;
    var username = get(user, 'username');
    var initialIsWatching = (_b = (_a = initialState === null || initialState === void 0 ? void 0 : initialState.isWatching) !== null && _a !== void 0 ? _a : get(user, 'isWatching')) !== null && _b !== void 0 ? _b : false;
    if (!username) {
        return { isWatching: initialIsWatching, isLoading: false };
    }
    var userState = getWatchState(state, username);
    return __assign({ isWatching: initialIsWatching, isLoading: false }, userState);
}
export function getIsWatching(state, username) {
    return get(getWatchState(state, username), 'isWatching');
}
export function getIsLoading(state, username) {
    return get(getWatchState(state, username), 'isLoading');
}
//# sourceMappingURL=selectors.js.map